import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    }, 1500);
  };

  return (
    <div className="d-flex flex-column min-vh-100" style={{ background: '#1f2028' }}>
      {/* Navigation Bar */}
      <div style={{ position: 'sticky', top: 0, zIndex: 1000, backgroundColor: '#1f2028', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="container-fluid px-3">
          <div className="d-flex align-items-center justify-content-between py-2" style={{ height: '48px' }}>
            {/* Logo/Brand */}
            <div>
              <Link to="/" className="text-decoration-none">
                <h5 className="text-light mb-0 fw-bold" style={{ fontSize: '1.1rem' }}>RE Calc</h5>
              </Link>
            </div>
            
            {/* Navigation Links */}
            <div>
              <Link to="/features" className="btn btn-link text-light text-decoration-none">Features</Link>
              <Link to="/faqs" className="btn btn-link text-light text-decoration-none">FAQs</Link>
              <Link to="/contact" className="btn btn-link text-light text-decoration-none">Get in Touch</Link>
              <Link to="/pricing" className="btn btn-link text-light text-decoration-none">Pricing</Link>
              <Link to="/signup" className="btn btn-primary btn-sm ms-3">Ready to Start?</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <h1 className="text-white mb-4">Get in Touch</h1>
            
            {submitted ? (
              <div className="card bg-dark border-secondary">
                <div className="card-body text-center py-5">
                  <i className="bi bi-check-circle-fill text-success" style={{ fontSize: '3rem' }}></i>
                  <h3 className="text-white mt-4">Thank You!</h3>
                  <p className="text-light mb-4">Your message has been sent successfully. We'll get back to you soon.</p>
                  <Link to="/" className="btn btn-primary">Return to Home</Link>
                </div>
              </div>
            ) : (
              <div className="card bg-dark border-secondary">
                <div className="card-body p-4">
                  <p className="text-light mb-4">
                    Have questions about RE Calc? Want to learn more about our features or pricing? 
                    Fill out the form below and our team will get back to you as soon as possible.
                  </p>
                  
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label text-muted">Name</label>
                      <input 
                        type="text" 
                        className="form-control bg-dark text-light border-secondary" 
                        id="name" 
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required 
                      />
                    </div>
                    
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label text-muted">Email</label>
                      <input 
                        type="email" 
                        className="form-control bg-dark text-light border-secondary" 
                        id="email" 
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required 
                      />
                    </div>
                    
                    <div className="mb-3">
                      <label htmlFor="subject" className="form-label text-muted">Subject</label>
                      <input 
                        type="text" 
                        className="form-control bg-dark text-light border-secondary" 
                        id="subject" 
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required 
                      />
                    </div>
                    
                    <div className="mb-4">
                      <label htmlFor="message" className="form-label text-muted">Message</label>
                      <textarea 
                        className="form-control bg-dark text-light border-secondary" 
                        id="message" 
                        name="message"
                        rows="5"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                    
                    <button 
                      type="submit" 
                      className="btn btn-primary w-100" 
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Sending...
                        </>
                      ) : 'Send Message'}
                    </button>
                  </form>
                </div>
              </div>
            )}
            
            <div className="row mt-5">
              <div className="col-md-4 mb-4 mb-md-0">
                <div className="card bg-dark border-secondary h-100">
                  <div className="card-body text-center p-4">
                    <i className="bi bi-envelope text-primary mb-3" style={{ fontSize: '2rem' }}></i>
                    <h5 className="text-white">Email</h5>
                    <p className="text-light">support@recalc.com</p>
                  </div>
                </div>
              </div>
              
              <div className="col-md-4 mb-4 mb-md-0">
                <div className="card bg-dark border-secondary h-100">
                  <div className="card-body text-center p-4">
                    <i className="bi bi-telephone text-primary mb-3" style={{ fontSize: '2rem' }}></i>
                    <h5 className="text-white">Phone</h5>
                    <p className="text-light">(555) 123-4567</p>
                  </div>
                </div>
              </div>
              
              <div className="col-md-4">
                <div className="card bg-dark border-secondary h-100">
                  <div className="card-body text-center p-4">
                    <i className="bi bi-chat-dots text-primary mb-3" style={{ fontSize: '2rem' }}></i>
                    <h5 className="text-white">Live Chat</h5>
                    <p className="text-light">Available 9am-5pm EST</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="py-4 mt-auto" style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <p className="text-muted mb-0 small">© 2025 RE Calc. All rights reserved.</p>
            <div>
              <Link to="/login" className="text-muted me-3 small">Login</Link>
              <Link to="/signup" className="text-muted small">Sign Up</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Contact;
